import * as _ from 'underscore'

import { ConvertHelper, DataProvider, ToastHelper } from "../helpers"
import { OpMeter } from "../models/core";
import { ColumnInfo, OpSchema } from '../models/custom';
import { Enums } from '../models/common';
import { DataProviderRequest } from './utils';

export class DataProviderMeters {

    // #region Ctor

    constructor(private dataProvider: DataProvider) { }

    // #endregion


    // #region Public Methods
    public getMeter = (idMeter: number): DataProviderRequest<OpMeter> => {
        const promise: JQueryPromise<OpMeter> = this.dataProvider
            .sendRequestWithSession('OpxGetMeter', { IdMeter: idMeter }, 'OpxGetMeterResult')
            .then((response: OpMeter) => {
                if (response != null) {
                    const meter: OpMeter = new OpMeter(response)

                    return OpMeter
                        .loadNavigationProperties(this.dataProvider, [meter])
                        .then((meter: OpMeter[]) => _.first(meter))
                }

                return null
            })
            .fail((error) => {
                const msg: string = ConvertHelper.getRequestErrorMessage(error)
                ToastHelper.showError(msg)
            })

        return DataProviderRequest.fromJQuery(promise)
    }

    public getMeterFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpMeter>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdMeter, 'OpxMeterFilter', 'OpxMeterFilterResult')
    }

    public deleteMeter = (opObj: OpMeter): JQueryPromise<OpMeter> => {
        opObj.opState = Enums.OpChangeState.Delete

        return this.dataProvider
            .sendRequestWithSession('OpxDeleteMeter', { ToBeDeleted: opObj.toJSON() }, null)
    }

    public saveMeter = (opObj: OpMeter): JQueryPromise<OpMeter> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveMeter', { ToBeSaved: opObj.toJSON() }, 'OpxSaveMeterResult')
            .then((data: any) => {
                if (data != null) {
                    const result: OpMeter = new OpMeter(data)

                    return OpMeter
                        .loadNavigationProperties(this.dataProvider, [result])
                        .then((meters: OpMeter[]) => {
                            return _.first(meters);
                        });
                }

                return null;
            })
    }

    //#region Schema

    public getMeterSchemas = (idMeter: number): JQueryPromise<OpSchema[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetMeterSchema', { IdMeter: idMeter }, 'OpxGetMeterSchemaResult')
            .then((response: any[]) => DataProvider.convertArrayResult<OpSchema>(response, OpSchema))
    }

    //#endregion

    // #endregion
}